export const faqs = [
  {
    id: 1,
    question: "爱情岛独家平台的内容多久更新一次？",
    answer: "我们平台的内容保持每日更新，编辑团队会持续筛选和推荐最新的优质内容。热门排行栏目实时反映用户关注度变化，精品推荐每周更新精选合集，确保您永远不会错过精彩内容。",
  },
  {
    id: 2,
    question: "平台上的高清资源支持哪些分辨率？",
    answer: "爱情岛独家平台全线内容支持1080P全高清画质，精品内容提供4K超高清选项。我们采用先进的HDR技术和智能码率适配，根据您的设备和网络环境自动优化播放体验，确保画面清晰流畅。",
  },
  {
    id: 3,
    question: "如何快速找到我感兴趣的内容类型？",
    answer: "您可以通过首页的六大分类入口（独家精品、高清资源、最新推荐、经典回顾、深度解读、热门排行）快速定位感兴趣的内容领域。每个分类下都有详细的内容列表，支持按时间、热度等维度排序。",
  },
  {
    id: 4,
    question: "平台是否需要注册才能使用？",
    answer: "目前爱情岛独家平台的绝大部分内容均可免费浏览，无需注册。我们相信优质内容应该被更多人看到。未来推出的个性化推荐和收藏功能会需要简单注册，但我们承诺始终保持核心内容的开放性。",
  },
  {
    id: 5,
    question: "爱情岛独家的内容来源是什么？",
    answer: "我们的内容来自专业的编辑团队筛选和各领域资深创作者的独家供稿。每一篇内容都经过严格的审核流程，确保原创性、品质感和价值性。我们也欢迎优秀的内容创作者加入我们的平台。",
  },
  {
    id: 6,
    question: "如何确保平台内容的品质？",
    answer: "我们建立了三重品质保障机制：第一，专业编辑团队的严格筛选；第二，用户评分和反馈系统的实时监控；第三，定期内容质量回顾和优化。只有通过所有环节的内容，才能最终呈现在平台上。",
  },
];